// extracted by mini-css-extract-plugin
export default {"Link":"Link_Link__1gn0N","icon":"Link_icon__kwx9l"};